import axios from 'axios';
import BankEntity from './bank-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

class BankService {

  hydrate (data) {
    return new BankEntity(
      data.id,
      data.attributes.acc_len,
      data.attributes.clr_max,
      data.attributes.clr_min,
      data.attributes.short_name,
      data.attributes.full_name
    );
  }

  hydrateCollection (data) {
    const col = [];

    for (let bank of data) {
      col.push(this.hydrate(bank));
    }

    return col;
  }

  get () {
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.get(
      'backend://banks?page[size]=50',
      {
        cancelToken: new axios.CancelToken(function executor (c) {
          pendingRequest.cancel = c;
        })
      })
      .then((response) => {
        return this.hydrateCollection(response.data.data);
      });
    return pendingRequest;
  }

  getByAccount (accountNr, accountClearingNr) {
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.get(
      `backend://banks?filter[accountNumber]=${accountClearingNr}-${accountNr}`,
      {
        cancelToken: new axios.CancelToken(function executor (c) {
          pendingRequest.cancel = c;
        })
      })
      .then((response) => {
        if (response.data.data[0]) {
          return this.hydrate(response.data.data[0]);
        }
        return null;
      });
    return pendingRequest;
  }
}

export default new BankService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/bank/bank-service.js
 **/